
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/kerberos-sso-setup",
      function () {
        return require("private-next-pages/learn/kerberos-sso-setup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/kerberos-sso-setup"])
      });
    }
  